import {
  mapDiscountToBookingDiscountLookup,
  type BookingDiscountLookup,
} from './discountsLookupMapper';

type BookingDiscountLookupSource = Parameters<typeof mapDiscountToBookingDiscountLookup>[0];

export const mapBookingDiscountsLookupData = (
  discounts: BookingDiscountLookupSource[] | undefined
): BookingDiscountLookup[] =>
  (discounts ?? [])
    .map((discount) => mapDiscountToBookingDiscountLookup(discount))
    .filter((discount): discount is BookingDiscountLookup => Boolean(discount));
